import { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import CatingServices from '../../../services/CastingService';

const ImageGallery = () => {
  const [images, setImages] = useState([]);

  const fetchImages = async () => {
    try {
      const res = await CatingServices.RequistionImages();
      console.log("Fetched image data:", res); // Debug
      setImages(Array.isArray(res) ? res: []);
    } catch (error) {
      console.error("Error fetching images:", error);
    }
  };
  

  useEffect(() => {
    fetchImages();
  }, []);

  const deleteImage = async (filename) => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: `Delete "${filename}" permanently?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirm.isConfirmed) {
      try {
        await CatingServices.RequistionDeleteImages(filename);
        setImages(images.filter(img => img !== filename));

        Swal.fire('Deleted!', `${filename} has been deleted.`, 'success');
      } catch (error) {
        console.error("Delete failed:", error);
        Swal.fire('Error!', 'Failed to delete the image.', 'error');
      }
    }
  };

  return (
    <div className="container mt-4">
      <h4 className="mb-3">Requisition Images</h4>
      <div className="row">
        {images.map((filename, index) => (
          <div className="col-md-3 mb-4" key={index}>
            <div className="card shadow-sm">
              <img
                src={`https://indigoinfra.in/img/requisitionform/${filename}`}
                alt={`img-${index}`}
                className="card-img-top"
                style={{ objectFit: 'cover', height: '200px' }}
              />
              <div className="card-body text-center">
                <small className="text-muted d-block mb-2">{filename}</small>
                <button
                  className="btn btn-sm btn-danger"
                  onClick={() => deleteImage(filename)}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        ))}
        {images.length === 0 && (
          <div className="text-center mt-4">
            <p>No images available.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageGallery;
